<template>
	<div
		id="app"
		:class="{
			subMenuClick: subMenuClick,
			hasHeader: showHeader,
			hasFooter: showFooter,
			showingModal: showingModal,
			fullMenu: fullMenu && !isPublic,
			showMenu: mobileMenu,
			hasMessage: hasTopMessage,
		}"
	>
		<Header
			:class="headerClasses"
			v-if="showPage&&showHeader"
			:siteName="siteName"
			@fullMenu="setFullMenu"
			:fullMenu="fullMenu"
			@mobileMenu="toggleMobileMenu"
			@menuLinkClick="menuLinkClick"
		/>
		<div class="wrapper" v-if="showPage">
			<TopMessage
				:message="globalMessage"
				:colour="globalMessageColour"
				:meta="globalMessageMeta"
				@resendConfirmEmail="resendConfirmEmail"
				@close="closeTopMessage"
				v-if="hasTopMessage"
			/>
			<router-view :key="routerViewKey" />
		</div>
		<Videos v-if="showPage&&showVideos" @close="closeVideos" />
		<InstructionTips
			:userInfo="userInfo" 
			v-if="showPage"
		/>
		<Footer v-if="showPage&&showFooter" :siteName="siteName" :class="footerClasses" />
		<loading :text="loadingText" v-if="loadingText != ''" />
		<vue-snotify></vue-snotify>
		<div :class="{ 'posthog-btn': true, show: showPostHogEvent }" v-if="showPostHog">
			<span @click="showPostHogEvent = !showPostHogEvent"></span>
			<FormInput
				type="text"
				v-model="posthogEventText"
				:noMarginBottom="true"
				placeholder="Short unique description"
				class="posthog-event-text"
				:required="false"
				@aKeyup.enter="sendPostHogEvent"
				@aKeyup.esc="showPostHogEvent = false"
			/>
		</div>
	</div>
</template>

<script>
	import Header from "./components/Header.vue";
	import Footer from "./components/Footer.vue";
	import posthog from 'posthog-js'
	import TopMessage from "./components/Display/TopMessage.vue";
	import InstructionTips from "./components/InstructionTips.vue";
	import { mapState, mapMutations, mapActions } from "vuex";
	import general from "./utils/general";
	import ApiService from "./services/api.service";
	const { TokenService } = require("./services/storage.service");
	import Videos from "./components/Videos.vue";
	import FormInput from "./components/Form/Input.vue";
	export default {
		name: "app",
		components: {
			Header,
			Footer,
			TopMessage,
			InstructionTips,
			Videos,
			FormInput
		},
		methods: {
			...mapMutations("general", [
				"updateVar",
				"printGlobalMessage",
				"updateLoadingText",
				"tableSorting",
			]),
			...mapActions("general", [
				"playVideo",
			]),
			sendPostHogEvent() {
				if (this.showPostHog) {
					if (this.posthogEventText) {
						posthog.capture("issue-stamp", { info: this.posthogEventText, version: version });
						this.posthogEventText = "";
						this.showPostHogEvent = false;
						this.$snotify.success("Issue sent");
					} else {
						this.$snotify.error("Please enter a description");
					}
				}
			},
			closeVideos() {
				this.updateVar({ varName: "showVideos", info: false });
				this.updateVar({ varName: "singleVideo", info: false });
				this.updateVar({ varName: "videoTitle", info: ''});
				general.modalClose();
			},
			showHideHeaderFooter(name) {
				this.updateVar({
					varName: "showHeader",
					info:
						[
							"login",
							"create-account",
							"create-account2",
							"create-account3",
							"forgot-password",
							"confirm-email",
							"reset-password",
							"subscriptions-public",
							"maintenance",
						].indexOf(name) < 0,
				});
				this.updateVar({
					varName: "showFooter",
					info:
						[
							"login",
							"create-account",
							"create-account2",
							"create-account3",
							"forgot-password",
							"confirm-email",
							"reset-password",
							"subscriptions-public",
							"maintenance",
						].indexOf(name) < 0,
				});
			},
			setFullMenu() {
				TokenService.saveFullMenu(!this.fullMenu);
				this.updateVar({ varName: "fullMenu", info: !this.fullMenu });
			},
			toggleMobileMenu(state) {
				state = typeof state !== "undefined" ? state : !this.mobileMenu;
				this.updateVar({ varName: "mobileMenu", info: state });
			},
			menuLinkClick() {
				this.subMenuClick = true;
				setTimeout(
					function() {
						this.subMenuClick = false;
					}.bind(this),
					1000
				);
			},
			closeTopMessage() {
				this.printGlobalMessage({ message: "" });
			},
			resendConfirmEmail() {
				this.updateLoadingText("One moment...");

				ApiService.get("users/confirm-email/resend")
					.then(
						function(info) {
							this.updateLoadingText();
							this.$snotify.success(info.data, "Confirm Email");
							this.closeTopMessage();
						}.bind(this)
					)
					.catch(
						function(err) {
							this.updateLoadingText();
						}.bind(this)
					);
			},
			loadProducts() {
				let products = {};

				ApiService.get("products")
					.then(
						function(info) {
							if (!info.data) return;

							info.data.forEach(
								function(product, i) {
									products[product.type] =
										products[product.type] || [];

									products[product.type].push(product);
								}.bind(this)
							);

							Object.keys(products).forEach(
								function(type) {
									products[type].sort((a, b) =>
										a[type] > b[type] ? 1 : -1
									);
								}.bind(this)
							);

							this.updateVar({
								varName: "products",
								info: products,
							});
						}.bind(this)
					)
					.catch(function(err) {
						console.log(err);
					});
			},
			loginChecker () {

				if ( this.loginChecked ) return;

				if (!this.$route.meta.public) {
					this.loginChecked = true;
					this.updateLoadingText(true);
					general.loginCheck(
						ApiService,
						function(ok, userInfo) {

							this.updateLoadingText();

							this.showPage = ok;

							let playVid = null;

							if (
								(!userInfo.videoViews ||
									!userInfo.videoViews.welcome) &&
								!!userInfo.showVideoPopups
							) {
								//playVid = "welcome";
							}

							this.updateVar({
								varName: "userInfo",
								info: userInfo
							});

							posthog.identify(
								userInfo._id,
								{ email: userInfo.email, name: userInfo.firstName + ' ' + userInfo.lastName }
							);

							if ( version ) {

								posthog.capture('version_used', { version: version });

							}

							if (playVid) {
								this.playVideo(playVid);
							}
						}.bind(this)
					);
				} else {
					this.showPage = true;
				}
				let fM =
					TokenService.getFullMenu() === false ||
					TokenService.getFullMenu() === "false"
						? false
						: true;
				this.updateVar({ varName: "fullMenu", info: fM });
				let gm = TokenService.getGlobalMessage();
				this.printGlobalMessage(gm);

				let tableSorting = TokenService.getTableSorting();
				this.updateVar({ varName: "tableSortingInfo", info: tableSorting });

				let tableHeadingVisibility = TokenService.getTableHeadingVisibility();
				
				this.updateVar({
					varName: "tableHeadingVisibility",
					info: tableHeadingVisibility,
				});

			}
		},
		computed: {
			...mapState("general", [
				"loadingText",
				"showHeader",
				"showFooter",
				"showingModal",
				"siteName",
				"fullMenu",
				"mobileMenu",
				"globalMessage",
				"globalMessageColour",
				"globalMessageMeta",
				"showVideos",
				"userInfo"
			]),
			showPostHog() {
				return typeof posthog !== "undefined" && (this.showAdmin || general.isDev());
			},
			showAdmin() {
				let extra = TokenService.getExtraInfo();

				return extra && extra.access && extra.access === "admin";
			},
			isPublic() {
				return this.$route.meta.public;
			},
			headerClasses() {
				if (this.$route.meta.headerClasses)
					return this.$route.meta.headerClasses;
				return {};
			},
			footerClasses() {
				if (this.$route.meta.footerClasses)
					return this.$route.meta.footerClasses;
				return {};
			},
			hasTopMessage() {
				return !this.isPublic && this.globalMessage !== "";
			},
			routerViewKey() {
				return this.$route.meta && this.$route.meta.nameAsKey
					? this.$route.name
					: this.$route.fullPath;
			},
		},
		data() {
			return {
				la: 1,
				showPage: false,
				showTopMessage: "",
				showTopMessageColour: "red",
				subMenuClick: false,
				showAnalysisCredits: false,
				loginChecked: false,
				posthogEventText: "",
				showPostHogEvent: false
			};
		},
		created() {
			document.title = this.siteName;
			this.showHideHeaderFooter(this.$route.name);
			this.loadProducts();
		},
		watch: {
			$route(to, from) {
				this.loginChecker ();
				this.showHideHeaderFooter(to.name);
				if (this.isPublic) {
					this.showPage = true;
					this.loginChecked = false;
				}
				if (to.path !== from.path) {
					window.scrollTo(0, 0);
				}
			},
		},
		beforeMount() {
			this.loginChecker ();
		},
	};
</script>
<style lang="less">
	@import "./../node_modules/vue-select/dist/vue-select.css";
	@import "./../node_modules/vue-snotify/styles/material.css";
	@import "./assets/css/less/_helper.less";
	@import "./assets/css/less/_settings.less";
	@import "./assets/css/less/_global.less";
	@imgRoot: "../../../";
	@import "./assets/css/less/components/_vue-select-override.less";
	@import "./assets/css/less/components/_section.less";
	@import "./assets/css/less/components/_buttons.less";
	@import "./assets/css/less/components/_forms.less";
	@import "./assets/css/less/components/_modals.less";
	@import "./assets/css/less/components/_content-header.less";
	@import "./assets/css/less/components/_disc.less";
	@import "./assets/css/less/components/_window-actions.less";
	@import "./assets/css/less/components/_help-info.less";
	@import "./assets/css/less/components/_info-panel.less";
	@import "./assets/css/less/components/_update-actions.less";
	@import "./assets/css/less/components/_vuejs-dialog-override.less";
	@import "./assets/css/less/components/_vue-snotify-override.less";
	@import "./assets/css/less/components/_vue-editor-override.less";
	.crisp-client .cc-kv6t[data-full-view="true"] .cc-1xry .cc-unoo .cc-7doi {
		background-color: @formDefaultColour !important;
	}
	.crisp-client #crisp-chatbox > div > a > span:nth-child(2) {
		background-color: @formDefaultColour !important;
	}
	.posthog-btn {
		position: fixed;
		left: 6px;
		bottom: 6px;
		display: flex;
		align-items: flex-end;
		justify-content: center;
		width: 14px;
		z-index: 9999999999;
		> span {
			width: 14px;
			height: 14px;
			background-color: @red;
			.rounded(50%);
			cursor: pointer;
			display: block;
		}
		.posthog-event-text {
			display: none;
			margin-left: 10px;
			width: 220px;
		}
		&.show {
			width: auto;
			.posthog-event-text {
				display: block;
			}
		}
	}
</style>
